/* eslint-disable import/no-default-export */
import React from 'react';
import loadable from '@loadable/component';
import { getConfig } from '@salesforce/pwa-kit-runtime/utils/ssr-config';
import { LoadFromServer } from './LoadFromServer';
import { LoadingIndicator } from './components/loading-indicator/LoadingIndicator';
import { AccountLazy } from './pages/account/AccountLazy';
import BuildStatus from './pages/build-status';
import { LoginSkeleton } from './pages/checkout/login/LoginSkeleton';
import { GiftCardDetailPage, GiftCards } from './pages/gift-cards';
import InitPWA from './pages/init';
import { PDPLazy } from './pages/pdp/PDPLazy';
import { SearchLazy } from './pages/search/SearchLazy';
import Show from './pages/show/Show';
import { PageUrl } from './pages/utils/page-url';
import { configureRoutes } from './utils/routes-utils';

const fallback = <LoadingIndicator isLoading />;

// Pages
const Checkout = loadable(() => import('./pages/checkout'), { fallback });
const Stores = loadable(() => import('./pages/stores'), { fallback });
const CheckoutLogin = loadable(() => import('./pages/checkout/login'), {
    fallback: <LoginSkeleton />,
});
const Cart = loadable(() => import('./pages/cart'), { fallback });
const CompareProducts = loadable(() => import('./pages/compare-products'), { fallback });
const Products = loadable(() => import('./pages/show/Products'), { fallback });
const DynamicCategory = loadable(() => import('./pages/show/DynamicCategory'), { fallback });

const routes = [
    {
        path: PageUrl.INIT_PWA,
        component: InitPWA,
        exact: true,
    },
    {
        path: PageUrl.BUILD_STATUS,
        component: BuildStatus,
        exact: true,
    },
    {
        path: PageUrl.SEARCH,
        component: SearchLazy,
        exact: false,
    },
    {
        path: PageUrl.PWA_SEARCH,
        component: SearchLazy,
        exact: false,
    },
    {
        path: PageUrl.CHECKOUT_LOGIN,
        component: CheckoutLogin,
        exact: true,
    },
    {
        path: PageUrl.CHECKOUT,
        component: Checkout,
        exact: false,
    },
    {
        path: PageUrl.STORES,
        component: Stores,
        exact: false,
    },
    {
        path: PageUrl.SHOW,
        component: Show,
        exact: false,
    },
    {
        path: PageUrl.PRODUCTS,
        component: Products,
        exact: false,
    },
    {
        path: PageUrl.PWA_PRODUCTS,
        component: Products,
        exact: false,
    },
    {
        path: PageUrl.SALE,
        component: Products,
        exact: false,
    },
    {
        path: PageUrl.PWA_SALE,
        component: Products,
        exact: false,
    },
    {
        path: PageUrl.NEW,
        component: Products,
        exact: false,
    },
    {
        path: PageUrl.PWA_NEW,
        component: Products,
        exact: false,
    },
    {
        path: PageUrl.COMPARE_PRODUCTS,
        component: CompareProducts,
        exact: true,
    },
    {
        // Prevent any local navigation to any SFCC PDP URL to do a redirection
        path: PageUrl.SG_PDP,
        exact: true,
        component: LoadFromServer,
    },
    {
        // Route for electronic gift cards
        path: PageUrl.ELECTRONIC_GIFT_CARD_PAGE,
        exact: true,
        component: GiftCardDetailPage,
    },
    {
        // Route for physical gift cards
        path: PageUrl.PHYSICAL_GIFT_CARD_PAGE,
        exact: true,
        component: GiftCardDetailPage,
    },
    {
        path: PageUrl.PDP,
        exact: true,
        component: PDPLazy,
    },
    {
        // This is only to handle the empty sku URL, since it is not handled in SFCC either
        // PDP is already handling this scenario
        path: PageUrl.PDP.replace(/[^/]*$/, ''),
        exact: true,
        component: PDPLazy,
    },
    {
        path: PageUrl.PWA_CART,
        exact: true,
        component: Cart,
    },
    {
        path: PageUrl.ACCOUNT,
        component: AccountLazy,
    },
    {
        path: PageUrl.GIFT_CARDS,
        exact: true,
        component: GiftCards,
    },
    {
        // Any PWA route should try to render a category page
        // and redirect to SFCC if not found
        path: '*',
        exact: false,
        component: DynamicCategory,
    },
];

function wrapRoutes() {
    const config = getConfig();
    return configureRoutes(routes, config, {
        ignoredRoutes: ['/callback', '*'],
    });
}

export default wrapRoutes;
